export type LayerStatus = "idle" | "loading" | "ready" | "error"

export function combineLayerStatus(statuses: LayerStatus[]): LayerStatus {
    if (statuses.some((s) => s === "error")) return "error"
    if (statuses.some((s) => s === "loading")) return "loading"
    if (statuses.every((s) => s === "ready")) return "ready"
    return "idle"
}
